{% block sw_order_detail_details_shipping_tracking_codes %}
    {% parent %}

    {% block sw_order_detail_details_shipping_paypal_carrier %}
    <div v-if="payPalResourceId" class="swag-paypal-order-carrier">
        <mt-text-field
            v-model="payPalCarrier"
            disabled
            :label="$t('sw-order-detail.payPalCarrierLabel')"
            :helpText="$t('sw-order-detail.payPalCarrierHelpText')"
            :placeholder="$t('sw-order-detail.payPalCarrierPlaceholder')"
        />

        <div
            class="swag-paypal-order-carrier__description"
            v-html="payPalCarrierDescription"
        />
    </div>
    {% endblock %}

{% endblock %}
